module.exports = __webpack_public_path__ + "static/media/carrorama-elite.0d161897.webp";